import React from 'react'
import styled from 'styled-components'


const JSONString =`{"name": "Floo noo", "description": "Oh Wow.","themes": [{"name": "Noodle","colorSet": [[0,1.0,1.0,1.0], [0.5,0.5,0.2,1.0]]},{"name": "Nardol","colorSet": [[0,0.2,0.4,0.3], [0.1,0.1,0.6,0.1]]},]}`

export const Json = () => (
    <p>{JSONString}</p>
)